import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';

const prefix = 'HusaGridTable';
const classes = {
  root: `${prefix}-root`,
  head: `${prefix}-head`,
  cell: `${prefix}-cell`,
  rowHeader: `${prefix}-row-header`
};
const TableStyled = styled(Table)(({ theme }) => ({
  [`&.${classes.root}`]: {
    '& td': {
      paddingLeft: theme.spacing(2),
      borderBottom: '1px solid rgba(224, 224, 224, 0.5)',
      transition: 'transform 0.3s ease-in-out'
    },
    '& .MuiIconButton-root': {
      padding: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5)
    }
  },
  [`& .${classes.head}`]: {
    textTransform: 'uppercase',
    '& th': {
      paddingLeft: theme.spacing(2),
      fontWeight: 'bold',
      color: theme.palette.grey[800],
      textTransform: 'none',
      position: 'relative',
      transition: 'transform 0.3s ease-in-out',
      '&:last-child': {
        textAlign: 'center'
      }
    }
  },
  [`& .${classes.cell}`]: {
    fontSize: '18px',
    padding: theme.spacing(0.5),
    transition: 'transform 0.3s ease-in-out',
    '&:last-child': {
      padding: 0,
      '& div': {
        display: 'flex',
        justifyContent: 'start'
      }
    }
  },
  [`& .${classes.rowHeader}`]: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  '.dragging': {
    opacity: 0.5
  }
}));

const TableRowStyled = styled(TableRow)(() => ({
  transition: 'background-color 0.2s, transform 0.3s ease-in-out',
  '&:hover': { backgroundColor: 'rgba(18,94,208,.1)' }
}));

export { classes, TableRowStyled, TableStyled };
